<template>
  <model-form
    ref="modelForm"
    :model="registerType"
  >
    <div class="column">
      <register-type-detail :register-type="registerType" />

      <div class="q-my-lg" />

      <register-page-table
        v-if="registerType.applicationType === APPLICATION_TYPES.REGISTER"
        :register-type="registerType"
      />
    </div>
  </model-form>
</template>
<script>

import { APPLICATION_TYPES } from 'src/models/register/RegisterType'
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'
import RegisterPageTable from 'src/modules/admin/register-type/components/RegisterPageTable'
import RegisterTypeDetail from 'src/modules/admin/register-type/components/RegisterTypeDetail'

export default {
  name: 'RegisterTypeForm',
  components: {
    ModelForm,
    RegisterTypeDetail,
    RegisterPageTable
  },
  models: {
    registerType: {
      location: true,
      stripeTerminalLocationOptions: true,
      styles: true,
      registerPages: {
        editing: true,
        registerGrid: true,
        categories: true
      }
    }
  },
  created () {
    _.extend(this, { APPLICATION_TYPES })
  },
  methods: {
    show (model, initialData) {
      this.$refs.modelForm.show(model, initialData)
    }
  }
}

</script>
